import React, {Component} from 'react';
import { Row, Col } from 'react-bootstrap';
// import { Checkbox, Radio } from 'react-icheck';
import PrintPreview from 'view/print/PrintPreview';
import PdfStore from 'stores/PdfStore';
import 'view/print/Print.css'

// const doctitle = ['ใบเคลม','ใบขับขี่','ตารางกรมธรรม์','พรบ.','สำเนาทะเบียนรถ','บัตรเจ้าของรถ','เลขครัชซี','สัญญาประณีประนอมยอมความ']
class PrintTNKBigJobDoc extends Component {

  constructor(...args){
    super(...args)
    this.state = {loading:false, data:{car:{car_registration_no:''},insurer:{claim_no:''}}}

    var cssPagedMedia = (function() {
      var style = document.createElement('style');
      document.head.appendChild(style);
      return function (rule) {
        style.innerHTML = rule;
      };
    }());

    cssPagedMedia.size = function(size) {
      cssPagedMedia('@page {size: ' + size + '}');
    };
    cssPagedMedia.size('portrait');
  }

  componentDidMount(){
    //this._notificationSystem = this.refs.notificationSystem;
    this.loadWorkCoverFileDoc()
  }

  

  loadWorkCoverFileDoc() {
    let {workNo} = this.props
    let that = this
    this.setState({ loading: true })
    PdfStore.loadWorkBigJobDoc(workNo,function(result) {
      let data = result.data
      //data['related_detail'] = Object.assign(that.state.data.related_detail,data.related_detail)
      data = Object.assign(that.state.data,data)
      that.setState({data:data})
    })  
  }

  onCopyPaperChange(){

  }

  renderLogoUrl(logoUrl){
    let imgUrl = ''
    if (process.env.NODE_ENV == "development") {
      imgUrl = 'https://demo2.bigfix.co/korat/pdf/'+logoUrl
    }else{
      imgUrl = '../'+logoUrl
    }
    return (<img src={imgUrl} />)
  }

  renderJobNo(){
    let workNo = this.props.workNo
    let jobNo = "";
    // let regex = /[+-]?\d+(?:\.\d+)?/g;

    let list = workNo.split("/");
    if(list.length>=2){      
      let nextList = list[0].split(".")
      if(nextList.length>=2){        
        jobNo = nextList[1]*1
      }else{        
        jobNo = decodeURIComponent(list[0]).replace( /^\D+/g, '')*1;          
      }  
    }else{
      
      
      jobNo = decodeURIComponent(workNo).replace( /^\D+/g, '')*1;          
    }

    return (<span className='text-red'>({jobNo})</span>)
  }

  renderComponentPage() {
    //let {doclist} = this.state
    let {car} = this.state.data

    return(
      <div style={{fontSize:'100px',fontWeight:'bold',height:'100%'}} className='text-center'>
        <div style={{position:'absolute',top: 'calc(30% - 256px)',left: '0',width: '100%'}}>
          <Row>
            <Col md={12} className='text-center'>{''}</Col>
          </Row>
          <Row>
            <Col md={12} className='text-center'>{car.car_registration_no} </Col>
          </Row>              
          <Row style={{marginTop:'20px'}}>
            <Col md={12} className='text-center'>{car.province} </Col>
          </Row>              
        </div>
        <div style={{position:'absolute',top: 'calc(50% + 100px)',left: '0',width: '100%'}}>
          <Row>
            <Col md={12} className='text-center'>{''}</Col>
          </Row>
          <Row>
            <Col md={12} className='text-center'>{car.car_registration_no} </Col>
          </Row>              
          <Row style={{marginTop:'20px'}}>
            <Col md={12} className='text-center'>{car.province} </Col>
          </Row>              
        </div>
      </div>  
    )
  }

  render() {
    let {loading} = this.state
    return(
      <PrintPreview 
        loading={loading} 
        leftBarTitle={'ใบปะหน้ารถ '+this.props.workNo}>
        {this.renderComponentPage()}
      </PrintPreview>
    )
  }

}  

PrintTNKBigJobDoc.defaultProps = {
  title: '',  
  mode : '1'
}
export default PrintTNKBigJobDoc;


// WEBPACK FOOTER //
// ./src/view/print/tnk/PrintTNKBigJobDoc.js